import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';
import Table from '../components/Table.js';

export default class TagView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#tagForm';
        this.formUrl = '/api/tag';
        this.formTpl = 'tag-form';
        this.formTitle = Lang.tagTitle;
        this.defaultObject = {
            title: '',
            description: '',
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();
        const self = this;

        if ($('#tags').length > 0) {
            this.table = new Table('tags', '/api/tag/table', [
                {data: 'name'},
                {data: 'description'},
                {data: 'status'},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    getFormData() {
        const data = super.getFormData();
        return data;
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const section = $('#tagsGroup');

        //Add
        section.parents('main').find('.add').off("click.tag").on("click.tag", function () {
            self.renderForm();
            return false;
        });

        //Delete
        section.off("click.tagd").on("click.tagd", ".delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(1)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: Lang.delsure,
                onConfirm: function () {
                    Api.send(`/api/tag/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });

            return false;
        });

        //Edit
        section.off("click.tage").on("click.tage", ".edit", function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/tag/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        //Active/Deactive
        section.off("click.tagde").on("click.tagde", ".deactive", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(2)').text();
            let status = $(this).parents('div:eq(0)').data('status');

            let ok_text = Lang.reactivate;
            if (status && status === 'on') {
                msg = Lang.tagDeactivateMsg;
                ok_text = Lang.deactivate;
                status = null;
            } else {
                status = 'on';
            }

            Confirm({
                ok: ok_text,
                title: name,
                msg: Lang.tagActivateMsg,
                onConfirm: function () {
                    Api.send(`/api/tag/${id}/updateStatus`, {status : status}, 'post').done(function () {
                        self.table.reload();
                    });
                }
            });
        });

        $(document).on('click', '#tagForm .jump-icon-achievement', function(){
            $('.jump-icon-clicked').removeClass('jump-icon-clicked');
            $(this).children(':first').addClass('jump-icon-clicked');
            let icon_alias = $(this).attr('data-alias');
            $("#tagForm input[name='icon']").val(icon_alias);
        });

    }
}